module.exports = __webpack_public_path__ + "img/SASS.470548b4.svg";